export default function BlogHero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative w-full h-[320px] md:h-[400px]">
        <img
          src="https://readdy.ai/api/search-image?query=A%20serene%20calm%20healing%20space%20with%20a%20wooden%20desk%20and%20an%20open%20journal%20next%20to%20a%20small%20potted%20plant%2C%20soft%20morning%20light%20streaming%20through%20sheer%20curtains%2C%20warm%20cream%20and%20sage%20green%20aesthetic%2C%20peaceful%20minimalist%20home%20office%2C%20botanical%20elements%2C%20editorial%20lifestyle%20photography%20with%20soft%20shadows%20and%20dreamy%20atmosphere&width=1600&height=800&seq=blog-hero-bg&orientation=landscape"
          alt="Blog hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4">
            The Healing &amp; Breakthrough Blog
          </h1>
          <p className="text-sm md:text-base text-white/85 max-w-xl leading-relaxed">
            Gentle insights on nervous system regulation, energy-safe coaching, chronic illness, and the art of healing at your own pace.
          </p>
        </div>
      </div>
    </section>
  );
}